import { computed } from 'vue';

import tt from '@/i18n/utils/translateText';
import { REGEX_PATTERNS } from '@/constants';

export const useCommonFormRules = () => {
  const defaultEmailRule = computed(() => ({
    pattern: REGEX_PATTERNS.onlyEmail,
    message: tt('shared.rule.emailCorrect'),
  }));

  return { defaultEmailRule };
};
